import { memo } from 'react';
import { Message } from 'semantic-ui-react';
import useAppSelector from 'hooks/useAppSelector';
import { formatCurrency } from 'utils';

interface OutbiddenByPriceProps {
  disclosedPrice: number;
}

function OutbiddenByPrice({ disclosedPrice }: OutbiddenByPriceProps) {
  const { loginUser } = useAppSelector((state) => state.user);
  const loginUserName = loginUser?.localized_name;

  return (
    <Message attached="bottom" color="yellow">
      <div className="ui padded grid">
        <div className="centered row" style={{ padding: '2em 0 0 0;' }}>
          <div className="four wide column" style={{ textAlign: 'center' }}>
            <div className="ui pointing below grey basic label">시작가</div>
          </div>
          <div className="eight wide column"></div>
          <div className="four wide column" style={{ textAlign: 'center' }}>
            <div className="ui pointing below grey basic label">최고 입찰가 (???)</div>
          </div>
        </div>

        <div className="row" style={{ padding: '0' }}>
          <div className="two wide column" style={{ padding: '0' }}></div>
          <div className="twelve wide column" style={{ padding: '0' }}>
            <div className="ui large progress warning" style={{ margin: '0' }}>
              <div className="bar" style={{ width: '83%' }}></div>
            </div>
          </div>
          <div className="two wide column" style={{ padding: '0' }}></div>
        </div>

        <div className="centered row" style={{ paddingTop: '0' }}>
          <div className="ten wide column" style={{ textAlign: 'center' }}></div>
          <div className="four wide column" style={{ textAlign: 'center' }}>
            <div className="ui pointing grey basic label">
              {loginUserName} 님의 입찰가 ({formatCurrency(disclosedPrice)})
            </div>
          </div>
          <div className="two wide column" style={{ textAlign: 'center' }}></div>
        </div>
      </div>
      <Message.List
        items={[
          '정상적으로 입찰되었지만, 더 높은 가격으로 입찰한 참여자가 있었습니다.',
          '시장교란행위 방지를 위해서 현재 최고 입찰가는 다른 참여자가 더 높은 가격을 제시할 때 까지 공개되지 않습니다.',
          '입찰 회수에는 제한이 없으니 다시 한 번 도전해보세요.',
        ]}
      />
    </Message>
  );
}

export default memo(OutbiddenByPrice);
